<template>
    <div>
        <template v-if="$route.query.back != 8">
            <template v-if="!bankId">
                <el-dropdown  @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
                    <span class="el-dropdown-link">
                        <el-tooltip content="收藏到题库" placement="top" effect="light">
                            <i v-if="question.isedit && !question.bqid"  class="el-icon-star-off to-bank item"></i>
                        </el-tooltip>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
                        <el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
                            <span>{{item.name}}</span>
                            <el-button class="btn" size="mini" @click="toAddToBank(item.id)" type="text">添加</el-button>
                        </el-dropdown-item>
                        <el-dropdown-item 
                            disabled
                            style="
                            font-size: 12px;
                            color: #ccc"
                            class="dropdown-item" 
                            v-if="bankList.length == 0">
                            <span>暂无题库</span>
                        </el-dropdown-item>
                        </div>

                        <el-dropdown-item v-if="isAddBank" divided style="text-align:center">
                            <el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
                                <el-form-item
                                style="margin-bottom: 0;"
                                prop="name"
                                :rules="[
                                    { required: true, message: '不能为空'},
                                ]"
                                >
                                    <el-input size="mini" v-model="bankForm.name"></el-input>
                                </el-form-item>
                                <el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
                                    <el-button type="text" @click="toAddBank">创建</el-button>
                                    <el-button  type="text" @click="cancelAddBank">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </el-dropdown-item>
                        
                        <el-dropdown-item v-else divided style="text-align:center">
                            <el-button  @click="createAddBank" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-tooltip content="取消收藏" placement="top" effect="light">
                    <i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid"  @click="toDelFormBank"></i>
                </el-tooltip>
            </template>
            <template v-if="!IsBankViewTest">
                
                <el-tooltip content="可视化逻辑" placement="top" effect="light">
                    <div @click="setJumpShow">
                        <el-badge 
                            v-if="question.logicalSettings.num" 
                            :value="question.logicalSettings.num" 
                            class="item">
                            <i class="el-icon-share"  ></i>
                        </el-badge>
                    </div>
                </el-tooltip>
                <el-tooltip content="高级脚本" placement="top" effect="light">
                    <div v-if="question.advancedScript"  @click="setMatrixRows">
                        <el-badge 
                            value="1" 
                            class="item">
                                <i class=" icon wjpc-iconfont wjpc-icon-tongji-03"></i>
                        </el-badge>
                    </div>
                </el-tooltip>
                <el-tooltip content="拖动题目" placement="top" effect="light">
                    <i  class="el-icon-rank item drag-handle"></i>
                </el-tooltip>
                
                <el-tooltip content="复制题目" placement="top" effect="light">
                    <i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="questionCopy(question)"></i>
                </el-tooltip>
                
                <el-tooltip content="删除题目" placement="top" effect="light">
                    <i class="el-icon-delete delete" v-if="question.isedit" @click="questionDelete(question.qid)"></i>
                </el-tooltip>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    // 试题操作：收藏到题库、逻辑、移动、复制、删除
    name: 'OperateWrap',
    data() {
        return {
            isAddBank: false,
            bankForm: {
                isSystemBank: 0, // 我的题库
                name: '',
                type: '未分类',
                bankType: 1
            },
        }
    },
    props: {
        question: {},
        bankId: { type: String, default: '' },
    },
    inject:{
        wjQuestionCopy: { default: null },
        questiondel: { default: null },
        jumpshow: { default: null },
        isBankViewTest: { default: null },
        getBankList: { default: null },
        BankList: { default: null },
        addToBank: { default: null },
        addBank: { default: null },
        delFormBank: { default: null },
        toSetMatrixRows: { default: null },
    },
    computed: {
        IsBankViewTest() {
            // console.log(' this.isBankViewTest :>> ',  this.isBankViewTest);
            return this.isBankViewTest()
        },
        bankList() {
            return this.BankList()
        }
    },
    created() {
        // console.log('-----------------------')
        if (this.question.bid && this.question.bqid) {
            this.getBankque()
        }
    },
    methods: {
        questionCopy(question) {
            if (this.wjQuestionCopy) {
                this.wjQuestionCopy(question)
            }
        },
        questionDelete(id) {
            if (this.questiondel) {
                this.questiondel(id)
            }
        },
        setJumpShow() {
            if (this.jumpshow) {
                this.jumpshow()
            }
        },
        setMatrixRows() {
            if (this.toSetMatrixRows) {
                this.toSetMatrixRows()
            }
        },
        // 获取试题题库列表
        getBankque() {
            let that = this;
			let data = this.$qs.stringify({
				bankId: this.question.bid, // 0自建题库 1系统题库
				difficulty: '',
				pageIndex: 1,
				pageSize: 10000,
				type: '', // 题库类别
				isDel: 0, // 是否为回收站列表
				bankType: 1 // 是否为0考试 1问卷
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankQuesList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
                        console.log('that.questio :>> ', that.questio);
						let index = res.resultBody.datas.findIndex( info => info.id == that.question.bqid)
                        if (index == -1) {
                            that.question.bid = ''
                            that.question.bqid = ''
                        }
					}
				}
			};
			this.$util.request(params);
        },
        // 题库start
        toGetBankList(e) {
            if (e) {
                this.getBankList()
            }
        },
        toAddToBank(id) {
            this.$refs.bankDropdown.hide()
            this.addToBank(this.question, id)
        },
        cancelAddBank() {
            this.isAddBank = false
            this.bankForm.name = ''
        },
        toAddBank() {
            this.$refs.ValidateForm.validate((valid) => {
                if (valid) {
                    this.isAddBank = false
                    this.addBank(this.bankForm, this.question.qid)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        createAddBank() {
            this.bankForm.name = ''
            this.isAddBank = true
        },
        toDelFormBank() {
            this.delFormBank(this.question)
        },
        
        // 题库end
    }
} 
</script>